import { render, staticRenderFns } from "./TagProjectPage.vue?vue&type=template&id=650bbc88&"
import script from "./TagProjectPage.vue?vue&type=script&lang=js&"
export * from "./TagProjectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports